<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 监控中心 </el-breadcrumb-item>
          <el-breadcrumb-item>调控管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑计划详细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="编辑调控" name="account">
            <el-form
              ref="ruleForm2"
              style="margin-top: 20px"
              :label-position="labelPosition"
            >
              <el-form-item
                label="柜子编码"
                label-width="200px"
                prop="planLoad"
              >
                <el-input
                  v-model="cabinetCode"
                  :disabled="true"
                  style="width: 150px"
                ></el-input>
              </el-form-item>
            </el-form>

            <el-row class="card-form">
              <el-col>
                <el-card shadow="hover">
                  <div class="tab-content">
                    <el-form
                      ref="ruleForm"
                      :model="model"
                      :rules="rules"
                      :label-position="labelPosition"
                    >
                      <el-form-item
                        label="计划调控负荷（单位:KW）"
                        label-width="200px"
                        prop="planLoad"
                      >
                        <el-input
                          v-model="model.planLoad"
                          style="width: 150px"
                        ></el-input>
                        <div style="width: 150px; margin: 0 auto">
                          <span class="span-info-text"
                            >* 负数表示充电:-1表示1kw充电</span
                          >
                          <span class="span-info-text">* 0表示不充不放</span>
                          <span class="span-info-text"
                            >* 正数表示放电,1表示1kw放电</span
                          >
                        </div>
                      </el-form-item>
                      <el-form-item label="开始时间" label-width="200px">
                        <el-time-picker
                          v-model="model.startTime"
                          :picker-options="{
                            start: '00:00',
                            step: '00:01',
                            end: '23:59',
                            selectableRange: '00:00:00 - 23:59:59',
                          }"
                          value-format="HH:mm"
                          format="HH:mm"
                          placeholder="选择时间"
                        >
                        </el-time-picker>
                      </el-form-item>
                      <el-form-item label="结束时间" label-width="200px">
                        <el-time-picker
                          v-model="model.endTime"
                          :picker-options="{
                            start: '00:00',
                            step: '00:01',
                            end: '23:59',
                            selectableRange: '00:00:00 - 23:59:59',
                          }"
                          format="HH:mm"
                          value-format="HH:mm"
                          placeholder="选择时间"
                        >
                        </el-time-picker>
                      </el-form-item>
                    </el-form>
                    <el-button
                      type="primary"
                      @click="add('ruleForm')"
                      style="margin-top: 20px"
                      >添加</el-button
                    >
                  </div>
                  <div>
                    <el-table :data="data1" stripe style="width: 100%">
                      <el-table-column
                        prop="planLoad"
                        label="计划调控负荷(kw)"
                        width="180"
                        align="center"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="startTime"
                        label="开始时间"
                        width="180"
                        align="center"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="endTime"
                        label="结束时间"
                        align="center"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </el-card>
              </el-col>
              <el-col style="max-width: 400px">
                <el-card shadow="hover">
                  <div slot="header" class="clearfix">
                    <span>时段/充电最大功率</span>
                  </div>

                  <div class="dl-box">
                    <ul>
                      <li
                        style="margin-bottom: 12px"
                        v-for="(fee, index) in feeModel.periodFeeConfigs"
                        :key="index"
                      >
                        {{ fee.startTime }}
                        <span style="margin: 0 10px 22px">至</span>
                        {{ fee.endTime }}
                        <span style="margin: 0 10px 22px"></span>

                        <span v-if="fee.controlMode == 1">充电</span>
                        <span v-else-if="fee.controlMode == 2">放电</span>
                        <span v-else="fee.controlMode == 3">空闲</span>

                        <span v-if="fee.periodType == 1">尖</span>
                        <span v-else-if="fee.periodType == 2">峰</span>
                        <span v-else-if="fee.periodType == 3">平</span>
                        <span v-else-if="fee.periodType == 4">谷</span>
                        <span v-else="fee.periodType == 5">高尖</span>

                        <span style="margin-left: 10px">{{
                          fee.maxPower
                        }}</span>
                        <span>kW</span>
                      </li>
                    </ul>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card shadow="hover">
                  <div slot="header" class="clearfix">
                    <span>费用</span>
                  </div>
                  <div class="dl-box-fee">
                    <div>尖时:{{ feeModel.fee1 }} 元</div>

                    <div>峰时:{{ feeModel.fee2 }} 元</div>

                    <div>平时:{{ feeModel.fee3 }} 元</div>

                    <div>谷时:{{ feeModel.fee4 }} 元</div>

                    <div>高尖时:{{ feeModel.fee5 }} 元</div>
                  </div>
                </el-card>
                <el-card shadow="hover" style="margin: 20px 0px 0px 0px">
                  <div slot="header" class="clearfix">
                    <span>其他</span>
                  </div>

                  <div class="dl-box">
                    <ul>
                      <li style="margin-bottom: 12px">
                        生效时间：<span style="display: block"></span>
                        {{ new Date(feeModel.effectiveTime).toLocaleString() }}
                      </li>

                      <li style="margin-bottom: 12px; display: none">
                        尖峰月： <span style="margin: 0 10px 22px"></span>
                        <span
                          v-for="(mon, index) in feeModel.topPeakMonths"
                          style="margin: 0 10px 0px 0px"
                          :key="index"
                          >{{ mon }}</span
                        >
                      </li>
                    </ul>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button plain @click="resetForm">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";

export default {
  data() {
    const validateTwoDecimals = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入调控负荷"));
      } else if (!/^-?\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("调控负荷只能输入最多两位小数和数字"));
      } else {
        callback();
      }
    };
    return {
      cabinetCode: "",
      flag: true,
      disabled: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      data: [],
      companyList: [], //公司列表
      form: {
        startTime: null,
        endTime: null,
      },
      data1: [],
      cabinetList: [],
      model: {
        id: "",
        planId: "",
        planLoad: "",
        startTime: "",
        endTime: "",
        planTime: "",
        source: "Fx",
      },
      feeModel: "",
      type: 0, //1复制 2修改
      rules: {
        planLoad: [
          { required: true, message: "请输入调控负荷", trigger: "blur" },
          { validator: validateTwoDecimals, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    add(formName) {
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          AxiosAjax({
            url: "/cabinet/haiyi/plan/detail",
            method: "post",
            data: _this.model,
            loading: true,
            success: function (res) {
              console.log(res.data.code);
              if (res.data.code == "000000") {
                _this.$message({
                  message: "新增成功",
                  type: "success",
                });
                _this.model.id = "";
                _this.model.planLoad = "";
                _this.model.startTime = "";
                _this.model.endTime = "";
                _this.getData();
              }
            },
          });
        } else {
          _this.$message({
            message: "请检查输入项",
            type: "error",
          });
          return false;
        }
      });
    },
    deleteItem(item) {
      this.data.forEach((el) => {
        if (el.id == item.id) {
          this.data.splice(this.data.indexOf(el), 1);
        }
      });
    },
    dataSort() {
      this.data.sort((a, b) => {
        // 将startTime转换为时间对象进行比较
        const timeA = new Date(`1970/01/01 ${a.startTime}`);
        const timeB = new Date(`1970/01/01 ${b.startTime}`);
        return timeA - timeB;
      });
    },
    // copy(item) {
    //   this.data.push(item);
    //   this.dataSort();
    // },

    submitForm: function (formName) {
      let _this = this; //当前页面

      _this.cabinetList.forEach((item) => {
        if (item.id == _this.model.deviceId) {
          _this.model.equipNo = item.cabinetCode;
        }
      });
      // if (this.flag) {
      console.log(this.model);
      // } else {
      //   // this.$refs[formName].validate((valid) => {
      //   //   if (valid) {
      //   //     if (JSON.stringify(this.$route.params) !== "{}") {
      //   //       AxiosAjax({
      //   //         url: "/cabinet/haiyi/plan/detail/update",
      //   //         method: "post",
      //   //         data: _this.model,
      //   //         loading: true,
      //   //         success: function (res) {
      //   //           console.log(res.data.code);
      //   //           setTimeout(() => {
      //   //             window.history.back(-1);
      //   //           }, 100);
      //   //           if (res.data.code == "000000") {
      //   //             _this.$message({
      //   //               message: "修改成功",
      //   //               type: "success",
      //   //             });
      //   //           }
      //   //         },
      //   //       });
      //   //     }
      //   //   }
      //   // });
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (JSON.stringify(this.$route.params) !== "{}") {
            AxiosAjax({
              url: "/cabinet/haiyi/plan/detail/update",
              method: "post",
              data: _this.model,
              loading: true,
              success: function (res) {
                console.log(res.data.code);
                setTimeout(() => {
                  window.history.back(-1);
                }, 100);
                if (res.data.code == "000000") {
                  _this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                }
              },
            });
          } else {
            AxiosAjax({
              url: "/cabinet/haiyi/plan/detail",
              method: "post",
              data: _this.model,
              loading: true,
              success: function (res) {
                console.log(res.data.code);
                if (res.data.code == "000000") {
                  setTimeout(() => {
                    window.history.back(-1);
                  }, 100);
                  _this.$message({
                    message: "新增成功",
                    type: "success",
                  });
                }
              },
            });
          }
        } else {
          _this.$message({
            message: "请检查输入项",
            type: "error",
          });
          return false;
        }
      });
    },
    deliveryDialogOpen: function () {
      let _this = this;
      //加载费率列表
      AxiosAjax({
        method: "get",
        url: "/cabinet/cabinet/feeConfig/" + _this.cabinetCode,
        loading: true,
        success: function (res) {
          if (res.data.data.code == "000000") {
            _this.feeModel = res.data.data.data;
          } else {
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },

    getData() {
      let _this = this;

      //加载子列表
      AxiosAjax({
        method: "get",
        url: "/cabinet/haiyi/plan/" + _this.model.planId,
        loading: true,
        success: function (res) {
          if (res.data.code == "000000") {
            _this.data1 = res.data.data.detailList;
          } else {
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
  },
  mounted: function () {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.model = this.$route.params;
    }
    if (this.$route.query.id) {
      this.model.planId = this.$route.query.id;
      this.flag = true;
      this.model.planTime = this.$route.query.planTime;
      this.cabinetCode = this.$route.query.cabinetCode;
      this.deliveryDialogOpen();
      this.getData();
    } else {
      this.flag = false;
    }
  },
};
</script>
<style scoped>
.dl-box-fee .el-input {
  width: 20%;
}
.dl-box-fee /deep/ .el-form-item__label {
  min-width: 80px;
}
.dl-box .el-form-item__label {
  font-weight: bold;
}
.el-date-editor.el-input {
  width: 150px;
}
.myselect .el-input {
  width: 100px;
}
.card-form {
  display: flex;
}
.card-form /deep/ .el-col {
  flex: 1;
}
/deep/ .el-form-item__error {
  position: static;
}
.span-info-text {
  color: #e6a23c;
  display: block;
  height: 25px;
  width: 400px;
  line-height: 25px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Regulation/PlanEdits.vue